<div class="" *ngIf="showCallWaiter || showCallPayment || showRating || showClearCart">
    <div class="order-actions">
        <ng-container *ngIf="showCallWaiter">
            <button
                tuiButton
                appearance="custom"
                (click)="handleClickCallWaiterBtn($event)"
                [disabled]="!cart.items.length || isLoading || false"
                [showLoader]="isLoading || isCallWaiterLoading || false"
                class="btn-call-waiter"
            >
                <div>
                    <tui-svg src="svg::bell"></tui-svg>
                    <div>{{ 'call_the_waiter' | transloco }}</div>
                </div>
            </button>
        </ng-container>

        <ng-container *ngIf="showCallPayment">
            <button
                tuiButton
                appearance="custom"
                (click)="handleClickCallPaymentBtn($event)"
                [disabled]="!cart.items.length || isLoading || false"
                [showLoader]="isLoading || false"
                class="btn-call-payment"
            >
                <div>
                    <tui-svg src="svg::credit-card"></tui-svg>
                    <div>{{ 'call_payment' | transloco }}</div>
                </div>
            </button>
        </ng-container>

        <ng-container *ngIf="showRating">
            <button
                tuiButton
                appearance="custom"
                [disabled]="isLoading || false"
                [showLoader]="isLoading || false"
                class="btn-rating"
                (click)="handleClickRatingBtn($event)"
            >
                <div>
                    <tui-svg src="svg::star"></tui-svg>
                    <div>{{ 'rate' | transloco }}</div>
                </div>
            </button>
        </ng-container>

        <ng-container *ngIf="showClearCart">
            <button
                tuiButton
                appearance="custom"
                [disabled]="isLoading || false"
                [showLoader]="isLoading || false"
                class="btn-refresh"
                (click)="handleClickClearCartBtn($event)"
            >
                <div>
                    <tui-svg src="svg::refresh"></tui-svg>
                    <div>{{ 'create_new_order' | transloco }}</div>
                </div>
            </button>
        </ng-container>
    </div>
</div>
